import React from 'react'
import { Button } from '@/components/ui/button'
import { Select } from 'antd'
import { IntroducingBrokerDto } from 'api/Trading-Accounts/Types/IntroducingBrokerDto'
import { FilterDescriptor } from 'store/grid/types'
import { isEmpty, isNotEmpty } from 'utils/is-empty'

export type SelectIntroducingBrokerModalOpenEvent = { filterId?: string; value: boolean }

export const SelectIntroducingBrokersFilter = ({
  children,
  filter,
  onFilterChange,
  onIntroducingBrokerModalOpen,
}: {
  children: React.ReactNode
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
  onIntroducingBrokerModalOpen?: (event: SelectIntroducingBrokerModalOpenEvent) => void
}) => {
  const introducingBrokerSelected = filter?.value ?? []
  const selectValues = filter?.value?.map((ib: IntroducingBrokerDto) => ib.id) ?? []

  if (isEmpty(selectValues) && onIntroducingBrokerModalOpen) {
    return (
      <Button
        onClick={() => onIntroducingBrokerModalOpen({ filterId: filter.id, value: true })}
        variant='outline'
        size='sm'
      >
        {children}
      </Button>
    )
  }

  if (isEmpty(selectValues) && onIntroducingBrokerModalOpen) {
    return (
      <Button
        onClick={() => onIntroducingBrokerModalOpen({ filterId: filter.id, value: true })}
        variant='outline'
        size='sm'
      >
        {children}
      </Button>
    )
  }

  return (
    <Select
      placeholder='Main IB'
      mode='multiple'
      value={selectValues}
      open={false}
      onFocus={() => {
        if (onIntroducingBrokerModalOpen) {
          onIntroducingBrokerModalOpen({ filterId: filter.id, value: true })
        }
      }}
      onChange={(values: string[]) => {
        const introducingBrokersState = isNotEmpty(values)
          ? introducingBrokerSelected.filter((x: IntroducingBrokerDto) => values.includes(x.id))
          : []

        onFilterChange.call(undefined, {
          nextFilter: { ...filter, value: introducingBrokersState },
        })
      }}
      style={{ width: '250px' }}
    >
      {introducingBrokerSelected.map((ib: IntroducingBrokerDto) => (
        <Select.Option value={ib.id} key={ib.id}>
          {ib.name}
        </Select.Option>
      ))}
    </Select>
  )
}
